import { render, staticRenderFns } from "./SwitchBranchConfirmation.vue?vue&type=template&id=6985c49d&"
import script from "./SwitchBranchConfirmation.vue?vue&type=script&lang=js&"
export * from "./SwitchBranchConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports